const REMOTE_ENTRY_FILE = "remoteEntry.js";

const loadRemote = (url, scope) =>
  new Promise((resolve, reject) => {
    const timestamp = `?t=${new Date().getTime()}`;

    // __webpack_require__.l is a Webpack internal function to load remote modules
    // loadScript function to load a script via script tag
    __webpack_require__.l(
      `${url}${timestamp}`,
      (event) => {
        if (event?.type === "load") {
          return resolve();
        }
        const realSrc = event?.target?.src;
        const error = new Error();
        error.message = "Loading script failed.\n(missing: " + realSrc + ")";
        error.name = "ScriptExternalLoadError";
        reject(error);
      },
      scope
    );
  });

const loadFromBucket = async (url) => {
  const response = await fetch(url);
  const scriptCode = await response.text();

  const script = document.createElement("script");
  script.text = scriptCode;
  document.head.appendChild(script);

  return new Promise((resolve, reject) => {
    return resolve();
  });
};

const initSharing = async () => {
  if (!__webpack_share_scopes__?.default) {
    await __webpack_init_sharing__("default");
  }
};

const initContainer = async (containerScope) => {
  try {
    if (!containerScope.__initialized && !containerScope.__initializing) {
      containerScope.__initializing = true;
      await containerScope.init(__webpack_share_scopes__.default);
      containerScope.__initialized = true;
      delete containerScope.__initializing;
    }
  } catch (error) {
    console.error(error);
  }
};

/*
  Dynamically import a remote module using Webpack's loading mechanism:
  https://webpack.js.org/concepts/module-federation/
*/
export const importRemote = async ({
  url,
  scope,
  module,
  remoteEntryFileName = REMOTE_ENTRY_FILE,
  isHosted = true,
}) => {
  if (!window[scope]) {
    if (isHosted) {
      await Promise.all([loadRemote(`${url}/${remoteEntryFileName}`, scope), initSharing()]);
    } else {
      await Promise.all([loadFromBucket(`${url}`), initSharing()]);
    }

    if (!window[scope]) {
      throw new Error(
        `Remote loaded successfully but ${scope} could not be found! Verify that the name is correct in the Webpack configuration!`
      );
    }
    const [, moduleFactory] = await Promise.all([
      initContainer(window[scope]),
      window[scope].get(module.startsWith("./") ? module : `./${module}`),
    ]);
    return moduleFactory();
  } else {
    const moduleFactory = await window[scope].get(module.startsWith("./") ? module : `./${module}`);
    return moduleFactory();
  }
};
